export default "__VITE_ASSET__atdXfr4p__"